import { webAssetUrl } from 'lib/utils/imageUtils';
import { Feedback } from 'components/Feedback';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';
import { useModal } from 'mui-modal-provider';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const FEEDBACK_TYPES = {
  spam: {
    title: 'Report spam',
    text: 'If you believe a user has been spamming you, please let us know below. We will review their account and history and take appropriate action.',
  },
};

const Contact = () => {
  const { showModal } = useModal();
  const router = useRouter();

  const handleModal = () => {
    const modal = showModal(Feedback, {
      onClose: () => {
        modal.destroy();
      },
      title: router.query.spam ? FEEDBACK_TYPES.spam.title : 'Send Us Feedback',
      text: router.query.spam ? FEEDBACK_TYPES.spam.text : 'Got feedback for us?  Enter it below.  We appreciate it!',
      messageBody: router.query.spam && `Request of review of messaging history for account: @${router.query.spam}`,
    });
  };

  useEffect(() => {
    if (router.query.spam) {
      handleModal();
    }
  }, [router]);

  return (
    <>
      <GondolaHead
        title="Contact"
        description="We'd love to hear from you! Contact the Gondola Team via email or report a bug."
        url="https://gondola.cc/contact"
      />
      <div
        className="flex text-center flex-col justify-center h-full bg-center bg-cover"
        style={{ backgroundImage: `url(${webAssetUrl('contact-bg.png')})` }}
      >
        <h1 className="font-bold text-5xl">
          Drop us a line!
        </h1>
        <div className="grid grid-cols-2 gap-4 p-4 mx-auto max-w-screen-md">
          <a className="btn-primary" target="_blank" rel="noreferrer" href="mailto:support@gondola.cc">
            Email Us
          </a>
          <button type="button" className="btn-primary" onClick={handleModal}>
            Send Feedback
          </button>
        </div>
      </div>
    </>
  );
};

export default Contact;
